export const acquisitionNetwork = (fields = {}) => {
  const value = (fields.platform || fields.utm_source || '').toLowerCase();
  const networks = {
    ig: ['Instagram', 'i-lucide-instagram'],
    instagram: ['Instagram', 'i-lucide-instagram'],
    fb: ['Facebook', 'i-lucide-facebook'],
    facebook: ['Facebook', 'i-lucide-facebook'],
    meta: ['Meta', 'i-lucide-megaphone'],
    messenger: ['Messenger', 'i-lucide-message-circle'],
    msg: ['Messenger', 'i-lucide-message-circle'],
    an: ['Audience Network', 'i-lucide-network'],
    audience_network: ['Audience Network', 'i-lucide-network'],
    google: ['Google', 'i-lucide-search'],
    whatsapp: ['WhatsApp', 'i-lucide-message-circle'],
  };
  const [name, icon] = networks[value] || [
    fields.platform || fields.utm_source,
    'i-lucide-link',
  ];
  return { name, icon };
};
